import { FC } from 'react';
import { IBasicProductsCare, IProductsCare } from '../../../../../../types/bussines';
import NudosCareCardWithPlans from './NudosCareCard';
import NudosCareCardLogistics from './NudosCareCardLogistics';

interface INudosCareCard {
  dataCareCard: IProductsCare;
  isEditable: boolean;
  handleEditProductsCare: (e: IBasicProductsCare) => void;
  isCareLogisticsEnabled: boolean;
}

/**
 * Selecciona la variante de tarjeta según el flag logístico activo.
 */
const NudosCareCard: FC<INudosCareCard> = ({ isCareLogisticsEnabled, ...cardProps }) => {
  if (isCareLogisticsEnabled) {
    return <NudosCareCardLogistics {...cardProps} />;
  }

  return <NudosCareCardWithPlans {...cardProps} />;
};

export { NudosCareCard };
